import { memo } from 'react';

const Banner = ({ imgUrl }) => {
  return imgUrl ? (
    <div className={'max-w-[1920px] m-auto h-[420px]'}>
      <img
        src={imgUrl}
        alt="爆款活动banner"
        className={'h-[100%] w-[100%]'}
        style={{
          objectFit: 'cover',
        }}
      />
    </div>
  ) : (
    <></>
  );
};

export default memo(Banner);
